/**
 * Atualiza a URL, e as tags <link rel="prev"> e <link rel="next">
 * @param {number} page - Número da página atual
 * @param {number} max_page - Total de páginas disponíveis
 */
function updatePaginationMeta(page, max_page) {
    // Atualiza o parâmetro "pagina" na URL (sem recarregar)
    var newUrl = new URL(window.location.href);
    newUrl.searchParams.set('pagina', page - 1);
    window.history.pushState({}, '', newUrl);

    // Remove links existentes <link rel="prev"> e <link rel="next">
    var head = document.querySelector('head');
    document.querySelectorAll('link[rel="prev"], link[rel="next"]').forEach(el => el.remove());

    // Cria o link <prev> se houver página anterior
    if ((page - 1) > 1) {
        var prev = document.createElement('link');
        prev.rel = 'prev';
        prev.href = `?pagina=${page - 2}`;
        head.appendChild(prev);
    }

    // Cria o link <next> se houver próxima página
    if (page <= max_page) {
        var next = document.createElement('link');
        next.rel = 'next';
        next.href = `?pagina=${page}`;
        head.appendChild(next);
    }
}
